// import { Link } from "react-router-dom";
// import { FaHome, FaArrowLeft, FaTools, FaSearch } from "react-icons/fa";
// import { MdErrorOutline } from "react-icons/md";

// const PageNotFound = () => {
//   return (
//     <section
//       className="d-flex align-items-center"
//       style={{
//         minHeight: "90vh",
//         background: "#f8fafc",
//       }}
//     >
//       <div className="container">
//         <div className="row align-items-center">

//           {/* Left Side */}
//           <div className="col-lg-6 text-center text-lg-start">

//             <span
//               className="badge bg-primary px-3 py-2 mb-3"
//               style={{ fontSize: "14px" }}
//             >
//               <MdErrorOutline className="me-2" />
//               Error 404
//             </span>

//             <h1
//               className="fw-bold"
//               style={{
//                 fontSize: "90px",
//                 color: "#0d6efd",
//                 lineHeight: "1",
//               }}
//             >
//               404
//             </h1>

//             <h2 className="fw-bold mb-3">
//               Oops! We couldn't find that page.
//             </h2>

//             <p className="text-muted fs-5">
//               The page you're looking for may have been moved, deleted,
//               or never existed. Let's help you get back on track.
//             </p>

//             <div className="d-flex flex-wrap gap-3 mt-4">

//               <Link
//                 to="/"
//                 className="btn btn-primary px-4 py-2"
//               >
//                 <FaHome className="me-2" />
//                 Back to Home
//               </Link>

//               <button
//                 className="btn btn-outline-primary px-4 py-2"
//                 onClick={() => window.history.back()}
//               >
//                 <FaArrowLeft className="me-2" />
//                 Go Back
//               </button>

//             </div>

//           </div>


// <div className="col-lg-6 text-center mt-5 mt-lg-0">

//   <img
//     src={`https://img.magnific.com/premium-vector/404-error-people-trying-connect-disconnected-wires-from-outlet_773186-1051.jpg`}
//     alt="404 Illustration"
//     className="img-fluid"
//     style={{
//       maxWidth: "100%",
//       width: "520px",
//       animation: "float 4s ease-in-out infinite"
//     }}
//   />

// </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default PageNotFound;

import { Link } from "react-router-dom";
import {
  FaHome,
  FaArrowLeft,
  FaTruckMoving,
  FaHardHat,
  FaTractor,
} from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";

const PageNotFound = () => {
  return (
    <section
      className="d-flex align-items-center position-relative overflow-hidden"
      style={{
        minHeight: "100vh",
        background: "#111",
      }}
    >
      {/* Background Blur */}
      <div
        style={{
          position: "absolute",
          width: "350px",
          height: "350px",
          background: "rgba(255,193,7,.12)",
          borderRadius: "50%",
          filter: "blur(90px)",
          top: "-80px",
          left: "-80px",
        }}
      />

      <div
        style={{
          position: "absolute",
          width: "280px",
          height: "280px",
          background: "rgba(255,193,7,.08)",
          borderRadius: "50%",
          filter: "blur(80px)",
          right: "-80px",
          bottom: "-80px",
        }}
      />

      <div className="container position-relative">
        <div className="row align-items-center">

          {/* LEFT */}

          <div className="col-lg-6">

            {/* Brand */}

            <h2 className="fw-bold mb-4">
              <span style={{ color: "var(--primary-color)" }}>K</span>
              <span className="text-white">RIMOTION</span>
            </h2>

            <span className="badge bg-warning text-dark px-3 py-2 mb-3">
              <MdErrorOutline className="me-2" />
              ERROR 404
            </span>

            <h1
              className="fw-bold text-white"
              style={{
                fontSize: "110px",
                lineHeight: 1,
              }}
            >
              404
            </h1>

            <h2 className="text-white fw-bold mt-3">
              Oops! Wrong Turn.
            </h2>

            <p
              className="text-secondary fs-5 mt-3"
              style={{
                maxWidth: "520px",
              }}
            >
              Looks like this page is under construction or has been moved.
              Let's get you back to where opportunities, machinery and
              services are waiting.
            </p>

            {/* Icons */}


            {/* Buttons */}

            <div className="d-flex flex-wrap gap-3">

              <Link
                to="/"
                className="btn btn-warning text-dark fw-bold px-4 py-3"
              >
                <FaHome className="me-2" />
                Back to Home
              </Link>

              <button
                className="btn btn-outline-light px-4 py-3"
                onClick={() => window.history.back()}
              >
                <FaArrowLeft className="me-2" />
                Go Back
              </button>

            </div>

          </div>

          {/* RIGHT */}

          <div className="col-lg-6 text-center mt-5 mt-lg-0">

            <img
              src="https://img.magnific.com/premium-vector/404-error-people-trying-connect-disconnected-wires-from-outlet_773186-1051.jpg"
              alt="404"
              className="img-fluid rounded-4 shadow-lg"
              style={{
                maxWidth: "520px",
                animation: "float 5s ease-in-out infinite",
                border: "4px solid rgba(255,255,255,.08)",
              }}
            />

          </div>

        </div>
      </div>
    </section>
  );
};

export default PageNotFound;

